// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBLs2ghkued0LF1xuvo6f8t1WcAVFPVvcs",
  authDomain: "cab-dvpl.firebaseapp.com",
  projectId: "cab-dvpl",
  storageBucket: "cab-dvpl.firebasestorage.app",
  messagingSenderId: "767586251930",
  appId: "1:767586251930:web:372c6e40c701d3105adb23",
  measurementId: "G-8DT9TWGJNL"
};

// Initialize Firebase (Primary App)
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize Secondary Firebase App (used ONLY for creating users without signing out the Admin)
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);
const functions = getFunctions(app);
const tenderFunctions = getFunctions(app, 'asia-south1');

export { auth, db, storage, secondaryAuth, functions, tenderFunctions };
